import { useState, useEffect } from "react";
import axios from "axios";
import { Apiurl } from "../../../shared/services/apirest";
import { getAuthHeader } from "../utils/investigadorUtils";

export const useCasos = (activeProjectId, initialSearch) => {
    const [casos, setCasos] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchCasos = async () => {
        setLoading(true);
        try {
            let url = `${Apiurl}casos/`;
            if (initialSearch) {
                url += `?documento=${initialSearch}`;
            }
            const res = await axios.get(url, getAuthHeader());
            let data = res.data;
            if (activeProjectId) {
                data = data.filter(c => c.proyecto === activeProjectId);
            }
            setCasos(data);
        } catch (err) {
            console.error("Error cargando casos:", err);
        } finally {
            setLoading(false);
        }
    };

    const deleteCaso = async (id) => {
        await axios.delete(`${Apiurl}casos/${id}/`, getAuthHeader());
        setCasos(prev => prev.filter(c => c.id !== id));
    };

    useEffect(() => {
        fetchCasos();
    }, [activeProjectId, initialSearch]);

    return { casos, loading, fetchCasos, deleteCaso };
};
